import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import ServicesSummary from './ServicesSummary';

const mapStateToProps = state => ({ venueId: selectActiveVenueId(state) });

export default connect(mapStateToProps)(ServicesSummary);
